import Backbone from 'backbone';
import React from 'react';
import ReactDOM from 'react-dom';

import {renderToDOM} from 'redux-stores/ReduxDOMRender';

import StudyItemsListing from '../studyItems/StudyItemsListing';
import StudyListingTabState from './StudyListingTabState';

export default class StudyListingTabView extends Backbone.View<StudyListingTabState> {
  static initClass(): void {
    this.prototype.className = 'buffer-tab buffer-tab--no-padding';
  }

  render(): this {
    const id = this.model.get('studyId');
    const type = this.model.get('studyType');
    renderToDOM(<StudyItemsListing studyId={id} studyType={type} />, this.el);
    return this;
  }

  remove(): Backbone.View<StudyListingTabState> {
    ReactDOM.unmountComponentAtNode(this.el);
    return super.remove();
  }
}

StudyListingTabView.initClass();
